import React from "react";
import { Link } from "react-router-dom";

export default function Breadcrumb({ pagename, mainpage }) {
  return (
    <>
      <section
        className="page-title"
        style={{ backgroundImage: `url('../images/img-1.jpg')` }}
      >
        <div className="Breadcrumboverlay"></div>
        <div className="container">
          <div className="title-box">
            <h1>{pagename}</h1>
            <ol className="breadcrumb">
              <li>
                <Link to="/">Home</Link>
              </li>
              {mainpage !== "" ? (
                <>
                  <li>
                    <Link to={`/${mainpage}`}>{mainpage}</Link>
                  </li>
                  <li>{pagename}</li>
                </>
              ) : (
                <li>{pagename}</li>
              )}
            </ol>
          </div>
        </div>
      </section>
    </>
  );
}
